import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import styled, { css } from 'styled-components';
import Svg, { NO_TRANSITION_CLASSNAME } from '../Svg';
import { highContrastTheme } from '../../../styling';
var Circle = /*#__PURE__*/styled.circle.withConfig({
  displayName: "InfoI__Circle",
  componentId: "sc-s12qji-0"
})(["", ""], highContrastTheme('dark', css(["fill:Canvas;"])));
var Rectangle = /*#__PURE__*/styled.rect.withConfig({
  displayName: "InfoI__Rectangle",
  componentId: "sc-s12qji-1"
})(["", ""], highContrastTheme('dark', css(["fill:Canvas;"])));

var _ref2 = /*#__PURE__*/React.createElement(Circle, {
  cx: "7.02502",
  cy: "5.14062",
  r: "0.625",
  fill: "white",
  className: NO_TRANSITION_CLASSNAME
});

var _ref3 = /*#__PURE__*/React.createElement(Rectangle, {
  x: "6.5",
  y: "6.51562",
  width: "1",
  height: "4",
  fill: "white",
  className: NO_TRANSITION_CLASSNAME
});

var InfoI = function InfoI(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#42368E' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.4rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 14 15",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7.51562",
    r: "7",
    fill: color
  }), _ref2, _ref3);
};

export default InfoI;